import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'
import { ChargeDebuggingData } from '@/types/admin/charge-debugging-data/chargeDebuggingData'

/**
 * Admin charge debugging data for a vehicle within a time range.
 * Used for debugging charge sessions in the admin panel.
 *
 * API endpoint: GET /api/admin/charge_debugging?vehicle_id={id}&start={iso}&end={iso}
 */
export type AdminChargeDebuggingResource = ChargeDebuggingData & ResourceModel

export const adminChargeDebuggingCollection =
  createResourceCollection<AdminChargeDebuggingResource>({
    name: 'adminChargeDebugging',
    apiConfig: {
      path: 'admin/charge_debugging',
    },
    selector: (state) => state.adminChargeDebugging,
  })

export const adminChargeDebuggingReducer =
  adminChargeDebuggingCollection.slice.reducer
